import type { CameraOrbit } from '@hi-level/3d-renderer';

/**
 * The angle to open the model on, taken off the link that was followed.
 *
 * A quotation can name the angle its floor was pictured from, so a client
 * following the link from their quote arrives looking at the mezzanine the way
 * whoever priced it meant them to — with the staircase in view rather than
 * behind the deck. It is only a starting position: everything here still turns.
 *
 * Both halves or neither. Half an angle describes no direction, and guessing
 * the other would open on a view nobody chose.
 */
export function parseOpenAngle(params: URLSearchParams): CameraOrbit | null {
  const azimuth = toDegrees(params.get('a'));
  const elevation = toDegrees(params.get('e'));
  if (azimuth === null || elevation === null) return null;
  return { azimuth, elevation };
}

/**
 * A number of degrees, or null.
 *
 * Blank is not zero. `Number('')` is 0 and finite, so "?a=253&e=" would
 * otherwise open on 253 round and 0 up — a view nobody chose.
 */
function toDegrees(raw: string | null): number | null {
  if (raw === null || raw.trim() === '') return null;
  const degrees = Number(raw);
  return Number.isFinite(degrees) ? degrees : null;
}
